export default __webpack_public_path__ + "static/generic_error_repeat_order-f30fe7f4a7ff795df01d5a837d33669e.png";